<div class="qa-grid mm-page">
  <h2 class="mb-4">{{_(KEYS.GRID.FILTER_GROUPS)}}</h2>

  <!-- new filter group: labelled fields instead of an anonymous row below the table -->
  <form class="card qa-fg-new" (ngSubmit)="newgroup.id && newgroup.name[locale] && onAdd()">
    <div class="card-body">
      <div class="qa-fg-new-title">{{_(KEYS.GRID.NEW_FILTER_GROUP)}}</div>
      <div class="qa-fg-new-row">
        <div class="qa-fg-new-id">
          <label for="newFilterGroupId">{{_(KEYS.GRID.ID)}}</label>
          <input class="form-control" id="newFilterGroupId" name="newFilterGroupId" [(ngModel)]="newgroup.id" (keyup)="sanitize(newgroup)"
                 maxlength="10" autocomplete="off" spellcheck="false" [placeholder]="_(KEYS.GRID.ID_PLACEHOLDER)">
        </div>
        <div class="qa-fg-new-name">
          <label for="newFilterGroupName">{{_(KEYS.GRID.NAME)}}</label>
          <input class="form-control" id="newFilterGroupName" name="newFilterGroupName" [(ngModel)]="newgroup.name[locale]" autocomplete="off">
        </div>
        <button type="submit" class="btn btn-primary" [disabled]="!newgroup.id || !newgroup.name[locale]">
          <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.GRID.ADD)}}
        </button>
      </div>
      <small class="qa-fg-new-hint">{{_(KEYS.GRID.ID_HINT)}}</small>
    </div>
  </form>

  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="filtergroup-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="filtergroup-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed">
        <div class="search-grid">
          <div class="search-field">
            <label>Id</label>
            <input class="form-control" [(ngModel)]="filter.id">
          </div>

          <div class="search-field">
            <label>{{_(KEYS.GRID.NAME)}}</label>
            <input class="form-control" [(ngModel)]="filter.name">
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="card-title mm-pane-header" [class.mm-pane-collapsed]="isGridCollapsed">
        <div class="mm-pane-actions">
          <button class="btn btn-sm btn-success d-inline-block" (click)="onRefresh()">
              <i class="fa fa-refresh"></i>
            </button>
        </div>
        <button type="button" class="mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="filtergroup-grid-results">
          <span class="mm-pane-toggle-label"><span>{{_(KEYS.GRID.FILTER_GROUPS)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      </div>
      <div id="filtergroup-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="mm-table-scroll"><table class="table">
          <thead>
          <tr>
            <th>{{_(KEYS.GRID.NAME)}}</th>
            <th class="id-col">{{_(KEYS.GRID.ID)}}</th>
            <th class="options-col"></th>
          </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let filtergroup of getFiltergroups(); let pos = index;">
              <tr *ngIf="isOnCurrentPage(pos)" [class.qa-fg-editing]="editing === filtergroup">
                <td>
                  <ng-container *ngIf="editing !== filtergroup; else nameEditor">
                    <span class="qa-fg-name">{{filtergroup.name[locale]}}</span>
                  </ng-container>
                  <ng-template #nameEditor>
                    <form (ngSubmit)="onSaveEdit()" class="qa-fg-edit-form">
                      <input class="form-control" name="editName" [(ngModel)]="editName"
                             (keyup.escape)="onCancelEdit()" [attr.aria-label]="_(KEYS.GRID.NAME)">
                    </form>
                  </ng-template>
                </td>
                <td class="id-col"><span class="qa-fg-id">{{filtergroup.id}}</span></td>
                <td class="options-col">
                  <ng-container *ngIf="editing !== filtergroup; else editActions">
                    <button type="button" class="btn btn-primary" (click)="onEdit(filtergroup)"
                            [attr.title]="_(KEYS.GRID.EDIT)" [attr.aria-label]="_(KEYS.GRID.EDIT)">
                      <i class="fa fa-edit" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-danger" (click)="onDeleteGroup(filtergroup)"
                            [attr.title]="_(KEYS.GRID.DELETE)" [attr.aria-label]="_(KEYS.GRID.DELETE)">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </ng-container>
                  <ng-template #editActions>
                    <button type="button" class="btn btn-primary" (click)="onSaveEdit()" [disabled]="!editName">
                      <i class="fa fa-save" aria-hidden="true"></i> {{_(KEYS.GRID.SAVE)}}
                    </button>
                    <button type="button" class="btn btn-outline-secondary" (click)="onCancelEdit()">{{_(KEYS.GRID.CANCEL)}}</button>
                  </ng-template>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table></div>

        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group qa-num-per-page">
              <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                <option value="2">2</option>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <span class="input-group-addon">{{_(KEYS.GRID.ENTRIES)}}</span>
            </div>
          </div>

          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="getFiltergroups().length"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>

      </div>
    </div>
  </div>
</div>
